const AppConstants = {
    EMAIL_FOR_SIGNIN: 'emailForSignIn',
    FIR_DOC_ID: 'firDocId'
};

export default AppConstants;
